module.exports = "<ng-container>\n  <div role=\"alert\" [ngClass]=\"classes\">\n    <button type=\"button\" class=\"close\" *ngIf=\"dismissible\" (click)=\"dismiss()\">\n     <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n   </button>\n    <i *ngIf=\"icon\" [ngClass]=\"'notification-icon fa fa-' + icon\"></i>\n    <span *ngIf=\"message\" class=\"notification-line\">{{ message }}</span>\n    <p *ngIf=\"text\" class=\"notification-text\">{{ text }}</p>\n  </div>\n</ng-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/notification/notification.component.html
// module id = ./src/app/shared/notification/notification.component.html
// module chunks = main